<template lang="pug">
  .component-create-entity-button
    .row.column.card.p-3
      .row
        .column
          label Clients
            SearchEntity(entity="clients",  @selected="add", v-model="search", clear-input).mb-1
              template(v-slot:default="result")
                .quick-search-result
                  div
                    small CL{{ result.result.id }}
                    div {{ result.result.name }} {{ result.result.surname }}
                    div(v-if="result.result.organization_name" )
                      small {{result.result.organization_name}}
                    div
                      small {{result.result.phone}}
          base-list(:component="component", :dataLoader="dataLoader", componentType="federationList" v-model="selected.delete", :selectableList="true", :resultsPerPage="5", ref="list")
      .row
        ActionButton(:action="save", v-if="selected.delete.length", confirm) Delete

</template>
<script type="text/babel">

  import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
  import BaseList from './BaseList'
  import SelectizeVehicle from '../../components/structure/ui/lists/selectize/SelectizeVehicle'
  import SelectizeGroupedParkingAssets
    from '../../components/structure/ui/lists/selectize/SelectizeGroupedParkingAssets'
  import SelectizeParkingGroup from '../../components/structure/ui/lists/selectize/SelectizeParkingGroup'
  import SelectizeClient from '../../components/structure/ui/lists/selectize/SelectizeClient'
  import ActionButton from '../../components/structure/ui/ActionButton'
  import SearchEntity from "../../components/structure/ui/SearchEntity.vue";
  import {EventBus} from "../../eventBus";

  export default {
    name: 'CreateFederationButtonModal',
    components: {
      SearchEntity,
      ActionButton,
      SelectizeClient, SelectizeParkingGroup, SelectizeGroupedParkingAssets, SelectizeVehicle, BaseList
    },
    data() {
      return {
        search:null,
        entity: null,
        component: require('src/components/backoffice/Client.vue'),
        loadedItems: [],
        selected: {

          add: [],
          delete: [],

        },
        body: {
          name: []
        }
      }
    },
    created() {
      if (this.item !== null) {
        for (let key in this.item) {
          this.entity[key] = this.item[key]
        }
      }
    },
    methods: {
      add(val) {
        this.$confirm('Are you sure?', `Do you really want to add CL${val}?`, () => {
          this.selected.add.push(val)
          this.search = null
          this.save()
        })
      },
      save() {
        const body = {
          'entity': 'client',
          ...this.selected
        }

        return KeplerBackofficeSdk.federations.select(this.$route.params.id).updateFederated(body, () => {
          EventBus.$emit('reload-list')
          this.selected.add = []
          this.selected.delete = []
        })
      },
      dataLoader(callback, page, resultsPerPage) {
        KeplerBackofficeSdk[`${this.$route.meta.name}`].select(this.$route.params.id).get((data) => {
          callback(data)
          this.loaded = true
          this.loadedItems = data.items.map((item) => {
            return '' + item.id
          })
        }, () => {
        }, page, resultsPerPage)
      },
    },
    props: ['item']
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// FederationClientsEdit.vue?59ed3f1a